import { useEffect, useState, type DependencyList } from 'react';

/** Minimal async loader hook. `reload()` re-runs the loader. */
export function useAsync<T>(
  fn: () => Promise<T>,
  deps: DependencyList,
): { data: T | undefined; loading: boolean; reload: () => void } {
  const [data, setData] = useState<T | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [n, setN] = useState(0);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    fn()
      .then((d) => {
        if (alive) setData(d);
      })
      .catch((err) => console.warn(err))
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, n]);
  return { data, loading, reload: () => setN((x) => x + 1) };
}

export function downloadBlob(bytes: BlobPart, filename: string, type: string): void {
  const blob = new Blob([bytes], { type });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
